import {checkMemberByEmail, checkMemberById} from "./auth/checkMember";
import {sendMagicLink} from "./auth/sendMagicLink";
import {loginViaMagicLink} from "./auth/loginViaMagicLink";
import {memberHasEmail} from "./auth/memberHasEmail";
import {httpsFunctions} from "../../../api/Api";
import {onrejected} from "./utils/onrejected";

export const Api = {
    checkMemberByEmail,
    checkMemberById,
    sendMagicLink,
    loginViaMagicLink,
    memberHasEmail,
    emailHasMultipleMembers: async (email) => {
        return httpsFunctions.post('/emailHasMultipleMembers', {
            email,
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then((result) => {
            return {
                error: result.data?.error,
                hasMultipleEmails: result.data?.data?.hasMultipleEmails,
                users: result.data?.data?.users,
            }
        }).catch(onrejected)
    },
    sendResetPasswordLink: async ({
                                      email,
                                      member,
                                  }) => {
        return httpsFunctions.post('/sendResetPasswordLink', {
            email,
            member,
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then((result) => {
            return {
                error: result.data?.error,
                ok: result.data?.data?.status === 'ok',
            }
        }).catch(onrejected)
    },
    login: async ({email, member, password}) => {
        return httpsFunctions.post('/loginUser', {
            email,
            member,
            password,
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then((result) => {
            return {
                error: result.data?.error,
                token: result.data?.data?.token,
                users: result.data?.data?.users,
            }
        }).catch(onrejected)
    },
}
